// ================================================= /
// ======   Hover Timer JS   ======================= /
// ================================================= /

/* global jQuery */

/**
 * Class for the hover timer functionality.
 * Adds a class to an element when it is hovered and removes it after a timer.
 */
class HoverTimer {

	/**
	 * Constructs the class and sets up instance variables.
	 */
	constructor() {

		this.selector = '.js-hover-timer';
		this.hoveredClass = 'was-hovered';
		this.eventNamespace = 'dispatchSkinHoverTimer';
		this.propertyName = 'hover-timer';
	}

	/**
	 * Initializes the class, sets up events.
	 */
	initialize() {

		if ( jQuery( this.selector ).length ) {

			// Input focus
			jQuery( '.site' ).on(
				`mouseenter.${this.eventNamespace}`,
				this.selector,
				this.handleMouseEnter.bind( this )
			);
		}
	}

	/**
	 * Handles the mouse enter.
	 * Adds the hovered class.
	 */
	handleMouseEnter( event ) {

		const element = jQuery( event.currentTarget );
		const elementTimer = element.css( `--${this.propertyName}` );

		element.addClass( this.hoveredClass );

		window.setTimeout(
			function() {
				element.removeClass( this.hoveredClass );
			}.bind( this ),
			parseInt( elementTimer || 1, 10 ) * 1000
		);
	}

}

const hoverTimer = new HoverTimer();
export default hoverTimer;



// WEBPACK FOOTER //
// ./src/js/inc/hover-timer.js